import { css } from "aphrodite";
import styles from "./styles";
import { Input, Typography } from "@mui/material";
import "../AccessibleLink/AccessibleLink.css";

const CustomInput = ({
    field,
    label,
    name,
    id,
    value,
    verticalMode = true,
    hideErrorMessage = false,
    form: { touched, errors },
    ...props
  }) => {
    const inputId = id || field?.name || name;
    const errorMessage = touched[field.name] && errors[field.name];
    const errorId = `${inputId}-error`;
    const accessibleName = label || props.placeholder;

    return (
      <div className={css([styles.container, (!verticalMode) && styles.rowButton])}>
        {label ? (
          <label htmlFor={inputId} className="visually-hidden">
            {label}
          </label>
        ) : null}
        <div className={css(
            styles.inputContainer,
            errorMessage && styles.error
            )}>
          <Input
            fullWidth
            disableUnderline={true}
            type="text"
            {...field}
            {...props}
            id={inputId}
            aria-label={label ? undefined : accessibleName}
            aria-invalid={Boolean(errorMessage)}
            aria-describedby={errorMessage ? errorId : undefined}
          />
        </div>
        {!hideErrorMessage && errorMessage && (
          <div className={css(styles.errorField)} id={errorId} role="alert">
            <Typography className={css(styles.error)} variant="subtitle2">
                {errors[field.name]}
            </Typography>
          </div>
        )}
      </div>
    );
  };
  
export default CustomInput;
